/**
 * 后台管理入口 - 改用新的侧边栏布局
 */

import { AdminLayout } from './admin/AdminLayout.jsx';

export default function AdminPage() {
  return <AdminLayout />;
}
